import { useState } from 'react';
import { Plus, Repeat } from 'lucide-react';
import { useParams } from 'react-router';

import { useCategories } from '@/api/category/use-categories.ts';
import { usePatterns } from '@/api/pattern/use-patterns.ts';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import AddPatternModal from '@/features/patterns/add-pattern-modal/add-pattern-modal.tsx';
import PatternRow from '@/features/patterns/pattern-row/pattern-row.tsx';
import AppContent from '@/layout/app-content';

const Patterns = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const { projectId } = useParams();

  const { data: categories } = useCategories(projectId);
  const { data: patterns, isLoading } = usePatterns(projectId);

  if (isLoading) {
    return (
      <AppContent title="Patterns">
        <Card>
          <CardContent className="p-6">
            <div className="text-center">Loading patterns...</div>
          </CardContent>
        </Card>
      </AppContent>
    );
  }

  return (
    <AppContent title="Patterns">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Patterns</CardTitle>
              <CardDescription>
                Auto-categorize recurring transfers by party (and optionally amount). Applied
                automatically on import, or run manually against uncategorized transfers.
              </CardDescription>
            </div>
            <Button onClick={() => setIsAddModalOpen(true)} data-icon="inline-end">
              Add Pattern
              <Plus className="size-3.5" />
            </Button>
          </div>
        </CardHeader>
      </Card>
      <div className="flex flex-col gap-2">
        <h2 className="text-base mb-1">All Patterns</h2>
        {patterns?.map((pattern) => (
          <PatternRow
            key={`${pattern.uuid}-${pattern.updatedAt}`}
            pattern={pattern}
            categories={categories}
          />
        ))}
        {!patterns?.length && (
          <div className="text-center py-8">
            <Repeat className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
            <CardTitle className="text-lg mb-2">No patterns yet</CardTitle>
            <CardDescription>
              Add your first pattern to auto-categorize recurring transfers.
            </CardDescription>
          </div>
        )}
      </div>
      {isAddModalOpen && <AddPatternModal onClose={() => setIsAddModalOpen(false)} />}
    </AppContent>
  );
};

export default Patterns;
